<mat-dialog-content class="modal-header"><h2 mat-dialog-title>EDITAR CALENDARIO</h2></mat-dialog-content>
<form #modelForm="ngForm" (ngSubmit)="onSubmit(modelForm)" appIdentityRevealed>
<mat-dialog-content class="modal-body">
  <div class="content">
    <div class="form-horizontal">
        <div class="form-group">
          <label class="col-md-2 control-label">Mes:</label>
          <div class="col-md-4">
            <mat-form-field appearance="outline">
              <mat-label>Año</mat-label>
              <input matInput type="text" [(ngModel)]="data.anio" name="anio" maxlength="40" disabled />
            </mat-form-field>
          </div>
          <label class="col-md-2 control-label">Mes:</label>
          <div class="col-md-4">
            <mat-form-field appearance="outline">
              <mat-label>Mes</mat-label>
              <input matInput type="text" [(ngModel)]="data.nombreMes" name="nombre" maxlength="40" disabled />
            </mat-form-field>
          </div>
      </div>
      <div class="form-group">
        <label class="col-md-2 control-label">Fecha Notificación:</label>
        <div class="col-md-4">
          <mat-form-field appearance="outline" hideRequiredMarker>
            <mat-label>Fecha Notificación</mat-label>
            <input
              matInput
              [matDatepicker]="pckrFechaNotificacion"
              [(ngModel)]="data.fechaNotificacion"
              id="fechaNotificacion"
              name="fechaNotificacion"
              [disabled]="disableFechaNotificacion"
              required
            />
            <mat-datepicker-toggle
              matSuffix
              [for]="pckrFechaNotificacion"
            ></mat-datepicker-toggle>
            <mat-datepicker #pckrFechaNotificacion></mat-datepicker>
            <!-- <mat-error *ngIf="fechaInicio.invalid">Requerido</mat-error> -->
          </mat-form-field>
        </div>
        <label class="col-md-2 control-label">Fecha Inicio:</label>
        <div class="col-md-4">
          <mat-form-field appearance="outline" hideRequiredMarker>
            <mat-label>Fecha Inicio</mat-label>
            <input
              matInput
              [matDatepicker]="pckrFechaInicio"
              [(ngModel)]="data.fechaInicio"
              id="fechaInicio"
              name="fechaInicio"
              [disabled]="disableFechaInicio"
              required
            />
            <mat-datepicker-toggle
              matSuffix
              [for]="pckrFechaInicio"
            ></mat-datepicker-toggle>
            <mat-datepicker #pckrFechaInicio></mat-datepicker>
            <!-- <mat-error *ngIf="fechaInicio.invalid">Requerido</mat-error> -->
          </mat-form-field>
        </div>
    </div>
  <div class="form-group">
    <label class="col-md-2 control-label">Fecha Fin:</label>
    <div class="col-md-4">
      <mat-form-field appearance="outline" hideRequiredMarker>
        <mat-label>Fecha Fin</mat-label>
        <input
          matInput
          [matDatepicker]="pckrFechaFin"
          [(ngModel)]="data.fechaFin"
          id="fechaFin"
          name="fechaFin"
          [disabled]="disableFechaFin"
          required
        />
        <mat-datepicker-toggle
          matSuffix
          [for]="pckrFechaFin"
        ></mat-datepicker-toggle>
        <mat-datepicker #pckrFechaFin></mat-datepicker>
        <!-- <mat-error *ngIf="fechaInicio.invalid">Requerido</mat-error> -->
      </mat-form-field>
    </div>
    <label class="col-md-2 control-label">Fecha Cierre:</label>
    <div class="col-md-4">
      <mat-form-field appearance="outline" hideRequiredMarker>
        <mat-label>Fecha Cierre</mat-label>
        <input
          matInput
          [matDatepicker]="pckrFechaCierre"
          [(ngModel)]="data.fechaCierre"
          id="fechaCierre"
          name="fechaCierre"
          required
        />
        <mat-datepicker-toggle
          matSuffix
          [for]="pckrFechaCierre"
        ></mat-datepicker-toggle>
        <mat-datepicker #pckrFechaCierre></mat-datepicker>
        <!-- <mat-error *ngIf="fechaInicio.invalid">Requerido</mat-error> -->
      </mat-form-field>
    </div>
</div>
  <div class="form-group">
    <label class="col-md-2 control-label">Comentarios:</label>
    <div class="col-md-10">
      <mat-form-field appearance="outline" hideRequiredMarker>
        <mat-label>Comentarios</mat-label>
        <textarea
                            matInput
                            placeholder="Comentarios"
                            rows="5"
                            [(ngModel)]="data.comentarioAmpliacion"                      
                            name="comentarioAmpliacion" maxlength="2000" required
                            ></textarea>
      </mat-form-field>
    </div>
  </div>
    </div>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end" class="modal-actions">
  <button type="submit" class="btn btn-naranja" mat-button [mat-dialog-close]="data" [disabled]="modelForm.invalid" >Guardar</button>
  <button type="button" class="btn btn-naranja2" mat-button  (click)="onNoClick()"><mat-icon>exit_to_app</mat-icon> Salir</button>
</mat-dialog-actions>
</form>
<!-- <div class="content">
    <div class="row items-push">
        <div class="col-sm-12 text-left">
            <ol class="breadcrumb push-10-t">
                <li><a [routerLink]="['/']">Inicio</a></li>
                <li><span class="link-effect">Información SSO</span></li>
                <li><span class="link-effect">Calendario</span></li>
                <li><span class="link-effect">Editar</span></li>
            </ol>
        </div>
    </div>
  </div>
  
  <div class="content">
    <div class="block">
      <div class="block-header">
        <h3 class="block-title">Editar Calendario SSO</h3>
      </div>
      <div class="block-content">
        
      </div>
    </div>
  </div>
   -->